import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
export default function Table({ footer, className, tableClassName, headerClassName, bodyClassName, footerClassName, trClassName, colWidths, headers = [], columns = [], data = [], }) {
    const renderHeader = (header) => {
        if (header.renderHeader) {
            return header.renderHeader(header);
        }
        return header.label;
    };
    const colWidth = (i) => {
        if (colWidths && colWidths.length === columns.length) {
            return { width: `${colWidths[i]}%` };
        }
        return {};
    };
    const renderHeaders = () => {
        return (React.createElement("tr", { className: classnames(trClassName) }, headers.map((header, i) => (React.createElement("th", { style: colWidth(i), "data-testid": `tableHeader-${header.field}`, key: header.field }, renderHeader(header))))));
    };
    const renderColumn = (value, col, row, colIndex) => {
        if (col.render) {
            return col.render(value, row, colIndex);
        }
        return value;
    };
    return (React.createElement("div", { className: classnames('table-wrapper', className) },
        React.createElement("table", { className: classnames('default-table', tableClassName) },
            React.createElement("thead", { "data-testid": "tableHead", className: classnames(headerClassName) }, renderHeaders()),
            React.createElement("tbody", { "data-testid": "tableBody", className: classnames(bodyClassName) }, data.map((row) => (React.createElement("tr", { className: classnames(trClassName), "data-testid": `tableRow${row.id && `-${row.id}`}`, key: row.id }, columns.map((column, i) => (React.createElement("td", { style: colWidth(i), "data-testid": `tableCell-${column.field}`, key: `${row.id}-${column.field}` }, renderColumn(row[column.field], column, row, i)))))))),
            footer && (React.createElement("tfoot", { "data-testid": "tableFooter", className: classnames(footerClassName) }, footer())))));
}
Table.propTypes = {
    headers: PropTypes.arrayOf(PropTypes.shape({
        field: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        renderHeader: PropTypes.func,
    })),
    data: PropTypes.array,
    columns: PropTypes.arrayOf(PropTypes.shape({
        field: PropTypes.string.isRequired,
        render: PropTypes.func,
    })),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    tableClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    headerClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    bodyClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    footerClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    footer: PropTypes.func,
};
